import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CHAT_STRINGS_PT, ChatStrings } from '../../chat.strings';
import { ChatProposalParams } from '../../chat.model';
import { formatPrice } from '../../chat.format';

/** `kind: 'proposal'` (7.2): a proposta registada no CRM, com valor e estado do último histórico. */
@Component({
  selector: 'chat-proposal-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './chat-proposal-card.component.html',
  styleUrls: ['./chat-proposal-card.component.css']
})
export class ChatProposalCardComponent implements OnChanges {
  @Input() params: Partial<ChatProposalParams> = {};
  @Input() canManage = false;
  @Input() dealId?: number | null;
  @Input() strings: ChatStrings = CHAT_STRINGS_PT;

  value = '';
  statusText = '';
  tone: 'ok' | 'warn' | 'off' = 'warn';

  ngOnChanges(): void {
    const p = this.params || {};
    this.value = p.value !== undefined && p.value !== null ? formatPrice(Number(p.value)) : '';
    this.statusText = p.statusName || '';
    const s = (p.statusName || '').toLowerCase();
    this.tone = /accept|aceit|complet|conclu/.test(s) ? 'ok' : /declin|recus|rejei/.test(s) ? 'off' : 'warn';
  }
}
